// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"modalheader_modalHeader__Ie4TS","heading":"modalheader_heading__D7wsF","subheading":"modalheader_subheading__SX4kB"};